import { cond } from 'lodash';
import { always, equals, T } from 'ramda';
import React from 'react';
import { GROWTH_CALCULATORS } from 'spw-constants';
import { CalculatorType } from 'spw-redux/modules/calculators/types';
import {
  IBuilding,
  IDepartment,
  IProject,
} from 'spw-redux/modules/projects/types';
import HeadcountSeatcountScenario from './headcount-seatcount-scenario';
import UsfScenario from './usf-scenario';
import MacroProgramming from './macro-programming';
import TotalProgram from './total-program';
import { PlainProgramScenario } from '../../models/Scenario';

const {
  buildingHeadcountSeatcount,
  buildingHeadcountSeatcountDepartments,
  floorHeadcountSeatcount,
  buildingUsf,
  floorUsf,
  macroProgramming,
  totalProgram,
} = GROWTH_CALCULATORS;

export const getCalculatorContent = (
  matcher: CalculatorType,
  props: {
    scenario: PlainProgramScenario;
    building: IBuilding;
    isEditingSavedScenario: boolean;
    calculatorType: CalculatorType;
    departments: IDepartment[];
    project: IProject;
    totalPrograms: PlainProgramScenario[];
    showDecimals: boolean;
    calculatorActions?: JSX.Element;
    disableHighlighting?: boolean;
    isRenderingForExport: boolean;
  }
) =>
  cond([
    [
      equals(buildingHeadcountSeatcount),
      () => <HeadcountSeatcountScenario {...props} />,
    ],
    [
      equals(buildingHeadcountSeatcountDepartments),
      () => <HeadcountSeatcountScenario {...props} />,
    ],
    [
      equals(floorHeadcountSeatcount),
      () => <HeadcountSeatcountScenario floors {...props} />,
    ],
    [equals(buildingUsf), () => <UsfScenario {...props} />],
    [equals(floorUsf), () => <UsfScenario floors {...props} />],
    [equals(macroProgramming), () => <MacroProgramming {...props} />],
    [equals(totalProgram), () => <TotalProgram {...props} />],
    [T, always(null)],
  ])(matcher);
